<template>
  <b-container class="p-3" fluid>
    <b-row>
      <b-col>
        <b-card no-body>
          <h6 slot="header" class="mb-0">
            <font-awesome-icon icon="id-badge" />ข้อมูลบัญชี
          </h6>
          <table class="table mb-0">
            <tbody>
              <tr>
                <td class="align-middle">
                  <strong>ชื่อผูใช้งาน (Username)</strong>
                </td>
                <td class="align-middle">
                  <b-form-input v-model.trim="form.username" />
                </td>
              </tr>
              <tr>
                <td class="align-middle">
                  <strong>รหัสผ่าน</strong>
                </td>
                <td class="align-middle">
                  <b-form-input v-model="form.password" type="password" />
                </td>
              </tr>
              <tr>
                <td class="align-middle">
                  <strong>ชื่อ-สกุล (ภาษาไทย)</strong>
                </td>
                <td class="align-middle">
                  <div class="row">
                    <div class="col"><b-form-input v-model.trim="form.firstName" placeholder="ชื่อ" /></div>
                    <div class="col"><b-form-input v-model.trim="form.lastName" placeholder="สกุล" /></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="align-middle">
                  <strong>ชื่อ-สกุล (ภาษาอังกฤษ)</strong>
                </td>
                <td class="align-middle">
                  <div class="row">
                    <div class="col"><b-form-input v-model.trim="form.enFirstName" placeholder="ชื่อ (ภาษาอังกฤษ)" /></div>
                    <div class="col"><b-form-input v-model.trim="form.enLastName" placeholder="สกุล (ภาษาอังกฤษ)" /></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="align-middle">
                  <strong>อีเมล</strong>
                </td>
                <td class="align-middle">
                  <b-form-input v-model.trim="form.email" />
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <b-card class="mt-3">
          <b-button variant="success" @click="submit">
            <font-awesome-icon icon="save" /> บันทึก
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import gql from 'graphql-tag'

export default {
  data () {
    return {
      form: {
        username: '',
        password: '',
        firstName: '',
        lastName: '',
        enFirstName: '',
        enLastName: '',
        email: ''
      }
    }
  },
  methods: {
    submit () {
      this.$apollo.mutate({
        mutation: gql`mutation ($input: UserOsdaCreateInput!) { userAddOsdaUser (input: $input) { id } }`,
        variables: { input: this.form }
      }).then(() => {
        this.$router.push({ name: 'settings.users.osda.index' })
      }).catch(() => {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 250px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
